import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
  /** Nome da área, para o usuário saber o que falhou. */
  area: string;
}

interface State {
  erro: Error | null;
}

/**
 * §8 e §11 item 11 — "nunca tela preta".
 *
 * O legado não tinha error boundary: qualquer `null` inesperado numa tela que
 * consome dado remoto derrubava a árvore inteira e o usuário via uma página em
 * branco, sem saber se tinha travado, deslogado ou perdido dados.
 *
 * Toda tela que consome dado remoto deve estar dentro de um destes.
 */
export class LimiteDeErro extends Component<Props, State> {
  override state: State = { erro: null };

  static getDerivedStateFromError(erro: Error): State {
    return { erro };
  }

  override componentDidCatch(erro: Error, info: ErrorInfo): void {
    // TODO(A7/observabilidade): enviar ao coletor de erros quando a esteira
    // de observabilidade estiver de pé.
    console.error(`[${this.props.area}] erro não tratado`, erro, info.componentStack);
  }

  override render(): ReactNode {
    if (this.state.erro === null) return this.props.children;

    return (
      <div
        role="alert"
        className="rounded-painel border border-borda bg-superficie-elevada p-8 text-center"
      >
        <h2 className="font-display text-lg text-conteudo-primario">
          Não foi possível carregar {this.props.area}
        </h2>
        <p className="mt-2 text-sm text-conteudo-secundario">
          Algo deu errado ao montar esta tela. Seus dados não foram perdidos.
        </p>
        <button
          type="button"
          onClick={() => this.setState({ erro: null })}
          className="mt-6 rounded-card bg-acento-ciano px-4 py-2 text-sm font-medium text-superficie-base transition hover:opacity-90"
        >
          Tentar novamente
        </button>
      </div>
    );
  }
}
